/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GradeSimulationViewModel } from "../types/GradeSimulationViewModel.ts";
import { gradeSimulationDisciplineViewModelSchema } from "./gradeSimulationDisciplineViewModelSchema.ts";
import { gradeSimulationTccItemViewModelSchema } from "./gradeSimulationTccItemViewModelSchema.ts";

export const gradeSimulationViewModelSchema = z.object({
  courseRegistrationId: z.optional(z.number().int()),
  classStudentId: z.optional(z.number().int()),
  personId: z.optional(z.number().int()),
  personName: z.string().nullish(),
  classStudentName: z.string().nullish(),
  finalGrade: z.number().nullish(),
  finalFrequency: z.number().nullish(),
  disciplines: z
    .array(z.lazy(() => gradeSimulationDisciplineViewModelSchema))
    .nullish(),
  tccGrades: z
    .array(z.lazy(() => gradeSimulationTccItemViewModelSchema))
    .nullish(),
}) as unknown as ToZod<GradeSimulationViewModel>;
